import React from "react";
import { SovosCheckbox } from "mosaic-react";
import { usePackageAssociation } from "./PackageAssociationContext";

const PackageAssociationCheckbox = ({ value }) => {
    const { id } = value || {};
    const { isChecked, toggleItem } = usePackageAssociation();

    if (!id) {
        return null;
    }

    return (
        <SovosCheckbox
            checked={isChecked(id)}
            onChange={() => toggleItem(id)}
            onClick={(event) => event.stopPropagation()}
        />
    );
};

export default PackageAssociationCheckbox;
